import { createSelector } from 'reselect';
import type { Selector } from 'reselect';

import type { ICustomer, ICustomersState } from './types';

export const selectCustomers = (state: ICustomersState) => state.customers;

export const selectIndexedCustomers = createSelector(selectCustomers, (customers) =>
  customers.reduce((indexed: { [x: string]: any }, customer: ICustomer) => {
    if (customer.customerReference) {
      indexed[customer.customerReference] = customer;
    }
    return indexed;
  }, {})
);

export const selectCustomer: Selector<ICustomersState> = createSelector(
  [selectIndexedCustomers, (_: ICustomersState, customerReference: string) => customerReference],
  (indexedCustomers, customerReference) => indexedCustomers[customerReference]
);
